import React, { useState, useEffect } from 'react';
import Card from './Card'
function Poker() {
    const [GameData, setGameData] = useState([]);
    const [Deck, setDeck] = useState([]);
    const [newGame, setNewGame] = useState(true);  // if this is true button will handle setting up a new game
    const [HandScore, setHandScore] = useState(0);
    const [Bank, setBank] = useState(500);

    const NumCards = 5;
    const DeckSize = 52;
    const handleClick = (num, hold) => {
        const newGameData = GameData.map((card, index) => {
            if (index === num) {
                return { ...card, hold: hold }


            }
            else
                return card;
        });

        setGameData(newGameData);
    };
    const Shuffle = (arr) => {
        var itm;
        for (itm in arr) {
            var si = Math.floor(Math.random() * DeckSize);
            console.log("SI = " + si);
            if (si > 51) {
                alert("GT51");
            }
            var tmp = arr[si];
            arr[si] = arr[itm];
            arr[itm] = tmp;
        }
    };
    


    useEffect(() => {
        // build the deck
        var cardInfo = [];
        for (var i = 1; i <= DeckSize; i++) {
            var suit = 0;
            suit = i % 4;
            var rank = 0;
            if (i < 5)
                rank = 14;
            else {
                rank = (i / 4) + 1;
                rank = Math.ceil(15 - rank);
                if (suit === 0) {
                    rank++;
                }
            }
            var cf = { suit: suit, rank: rank, cardNum: i, hold: true };
            cardInfo.push(cf);
        }

        setDeck(cardInfo);
        // initialize the five now
        var hand = [];
        for (var handNum = 0; handNum < NumCards; ++handNum) {
            hand.push(cardInfo[0]);
        }
        setGameData(hand);

    }, []);
    /*useEffect(() => {
        
        if (GameData.length > 10) {

            setHandScore(HandScore());
        } else {
            console.log("no data");
        }
        

    }, [GameData]);*/

    const GetHandScore = (GDArr) => {
        var isStraight = true;
        var isFlush = true;
        var min = 20;
        var max = -99;
        var diffCards = [];
        var ranks = Array(15).fill(0);
        for (var i = 0; i < NumCards; ++i) {
            // fill ranks
            ranks[GDArr[i].rank]++;

            if (isFlush && i > 0 && GDArr[i].suit !== GDArr[i - 1].suit) {
                isFlush = false;
            }
            if (GDArr[i] > max) {
                max = GDArr[i];
            }
            if (GDArr[i] < min) {
                min = GDArr[i];
            }
            if (diffCards.includes(GDArr[i])) {
                isStraight = false;
            }
            if (!isFlush && !isStraight) {
                break;
            }
            diffCards.push(GDArr[i]);
        }
        if (isStraight &&(!((max - min) === 4))) {
            isStraight = false;
        }
        if (isFlush && isStraight) {
            if (ranks[15] === 1) {
                return 37; // woohoo RoyalFlush
            } else {
                return 29;  // straight flush

            }
        }
        if (isFlush) {
            return 8;
        }
        if (isStraight) {
            return 5;
        }
        // last find 4 of a kind/ fh/2 pair, pair
        var onepair = false;
        var threekind = false;
        for (var rnknum = 0; rnknum < 15; rnknum++) {
            if (ranks[rnknum] === 2) {
                if (onepair) {
                    return 2;
                } else if (threekind) {
                    return 13;
                }
                onepair = true;
            }
            if (ranks[rnknum] === 4) {
                return 21;
            }
            if (ranks[rnknum] === 3) {
                if (onepair) {
                    return 13;
                }
                threekind = true;
            }

        }
        if (threekind)
            return 3;
        if (onepair)
            return 1;


        return 0;


    };








  /*  const isStraight = () => {
        var min = 20;
        var max = -99;
        var diffCards = [];
        for (var i = 0; i < NumCards; ++i) {
            if (GameData[i] > max) {
                max = GameData[i];
            }
            if (GameData[i] < min) {
                min = GameData[i];
            }
            if (diffCards.includes(GameData[i])) {
                return false;
            }
            diffCards.push(GameData[i]);
        }
        if ((max - min) === 4) {
            return true;
        }
        return true;
    }
    */
    




    const shuffleDeck = () => {
        setHandScore(0);
        if (newGame) {
            setBank(Bank - 1);
            var tmpDeck = [...Deck];
            Shuffle(tmpDeck);
            setDeck(tmpDeck);
            var hand = [];
            for (var handNum = 0; handNum < NumCards; ++handNum) {
                hand.push(Deck[handNum]);
                hand[handNum].hold = true;
            }
            console.log("HAND");
            console.log(hand);
            setGameData(hand);
        } else {
            var tmpHand = [...GameData];
            for (var hn = 0; hn < NumCards; ++hn) {
                if (!tmpHand[hn].hold) {
                    tmpHand[hn] = Deck[hn + 5];

                }
            }
            setGameData(tmpHand);
            var hs = GetHandScore(tmpHand);
            setHandScore(hs);
            setBank(Bank + hs);
             

        }
        setNewGame(!newGame);

    }
    return (
        <div className="container">
            <div className="row"  >
                <div className="col">
                    <h1>5 Card Poker</h1>
                    <p>Simple 5 card poker game.  I originally build this using vanilla javascript.  This version is using React.</p>
                </div>
            </div>
            <div className="row"  >
                < div className="col-lg-2">
                    <button onClick={() => { shuffleDeck(); }}  >{newGame ? 'Deal New Hand' : 'Draw cards'}</button>
                </div>
                < div className="col-lg-2">
                          Cash: {Bank }<br/>
                    Hand Score: {HandScore}
                </div>
            </div>

            <div className="row"  >
                {GameData.map((cardInfo, index) =>
                    <div key={index} className="col-lg-1"> <Card key={index} CardProps={cardInfo} HandleClick={handleClick} index={index}  ></Card></div>
                )}
            </div>
        </div>);

}

export default Poker

